import { render } from "./QuizSummaryCard.vue?vue&type=template&id=5ae99d0c"
import script from "./QuizSummaryCard.vue?vue&type=script&lang=js"
export * from "./QuizSummaryCard.vue?vue&type=script&lang=js"

import "./QuizSummaryCard.vue?vue&type=style&index=0&id=5ae99d0c&lang=scss"
script.render = render

export default script